import { render } from "./ConsultantMailPreferences.vue?vue&type=template&id=2274d01e"
import script from "./ConsultantMailPreferences.vue?vue&type=script&lang=js"
export * from "./ConsultantMailPreferences.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__